import useActions from '@components/ArtBoard/Node/hooks/useActions'
import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import cx from 'classnames'
import type React from 'react'
import { useSelector } from 'react-redux'

import { TREE_MATRIX } from '@/constants/constants'
import css from './Input.module.scss'

type Props = {
  id: string
  name: string
}

let timeout: any

const Input: React.FC<Props> = (props) => {
  const { onRenameNode } = useActions(props.id)

  const isProjectMobile = useSelector(
    migrationProjectSelector.getIsProjectMobile
  )
  const tree = useSelector(migrationProjectSelector.getProjectTreeType)

  const resize = (ref: HTMLTextAreaElement) => {
    ref.style.height = 'auto'
    ref.style.height = `${ref.scrollHeight}px`
  }

  const onFocus = (e: React.FocusEvent<HTMLTextAreaElement>) => {
    const { target } = e
    const { value } = target

    target.setSelectionRange(value.length, value.length)
  }

  const onChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    const { target } = e

    const isContainsOnlySpaces =
      target.value.length > 0 && target.value.trim().length === 0
    const nodeName = isContainsOnlySpaces ? ' ' : target.value.trim()

    resize(target)

    clearTimeout(timeout)

    // refactor
    // @todo control changes after exit from editable state
    if (props.name !== nodeName) {
      timeout = setTimeout(() => {
        onRenameNode(nodeName)
      }, 200)
    }
  }

  const classes = {
    container: cx(css.container, {
      [css.mobile]: isProjectMobile,

      // project tree
      [css.matrix]: tree === TREE_MATRIX,
    }),
  }

  return (
    <textarea
      className={classes.container}
      rows={1}
      ref={(curr) => {
        if (curr) {
          curr.focus()

          resize(curr)
        }
      }}
      defaultValue={props.name}
      onFocus={onFocus}
      onChange={onChange}
    />
  )
}

export default Input
